angular.module('components.caOrderMetaData', [])
    .component('caOrderMetaData', {
        templateUrl: 'main/order/orderdelivery/components/ordermetadata.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            disabled: '<',
            isHidden: '<',
            isCopying: '<',
            orderChangeCount: '=',
            order: '=',
            deliveryPlanningTemplate: '=',
            initOrderType: '<',
            initCompany: '<',
            setCollectionAutomatically: '<',
            setCurrencyRateAutomatically: '<'
        },
        controller: controller
    });

// @ngInject
function controller($scope, ToasterService, OrdersApiService, OrderService, Rms2OrdersApiService, EditDeliveryPlanningDialogService) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    var errorColor = '#ff0000';
    var noErrorColor = '#ffffff';
    vm.enableDeliveryPlanning = false;
    vm.orderTypes = [];
    vm.companies = [];
    vm.allLocations = [];
    vm.allUserLocations = [];
    vm.locations = [];
    vm.destinations = [];
    vm.collections = [];
    vm.deliveryTerms = [];
    vm.users = [];
    vm.isCreatedOrNew = isCreatedOrNew()
    vm.orderUpdated = orderUpdated;

    //vm.deliveryPlanningTemplate = [];

    vm.getOrderTypeRowStyle = getOrderTypeRowStyle;
    vm.getFromLocationRowStyle = getFromLocationRowStyle;
    vm.getDestinationRowStyle = getDestinationRowStyle;
    vm.getCompanyRowStyle = getCompanyRowStyle;
    vm.getCollectionRowStyle = getCollectionRowStyle;
    vm.getCurrencyStyle = getCurrencyStyle;
    vm.setCurrencyRate = setCurrencyRate;
    vm.canChangeCurrency = canChangeCurrency;
    vm.canChangeCompany = canChangeCompany;
    vm.canChangeFromLocation = canChangeFromLocation;
    vm.canChangeDestination = canChangeDestination;
    vm.canChangeCollection = canChangeCollection;
    vm.openEditDeliveryPlanning = openEditDeliveryPlanning;
    vm.isDeliveryPlanningDisabled = isDeliveryPlanningDisabled;
    vm.isDeliveryPlanningEnabled = isDeliveryPlanningEnabled;
    vm.dateChangeDeliveryPlanningDialog = dateChangeDeliveryPlanningDialog;
    vm.resetDeliveryPlanningTemplate = resetDeliveryPlanningTemplate;

    function onInit() {
        OrdersApiService.getOrderTypes().then(function(response) {
            vm.orderTypes = response;

            if (vm.initOrderType && vm.initOrderType !== null) {
                vm.order.orderType = _.find(vm.orderTypes, function(o) {
                    return o.orderSystemType === vm.initOrderType;
                });
            }
            vm.orderChangeCount += 1;
        }, function(error) {
            ToasterService.showError();
        });
        OrdersApiService.getCompanies().then(function(response) {
            vm.companies = response;

            if (vm.initCompany && vm.initCompany !== null) {
                vm.order.company = _.find(vm.companies, function(c) {
                    return c.id === vm.initCompany;
                });
            }
        }, function(error) {
            ToasterService.showError(error.message);
        });

        OrdersApiService.getCurrencyDefault().then(function(response) {
            vm.defaultCurrency = response;
            setCurrencyToDefault();
        }, function(error) {
            ToasterService.showError(error.message);
        });

        OrdersApiService.getLocationsDependingOnUser({filterInactiveLocations: true}).then(function(response) {
            vm.allUserLocations = response;
            setLocationsDependingOnOrderType();
        }, function(error) {
            ToasterService.showError(error.message);
        });

        OrdersApiService.getLocations({filterInactiveLocations: true}).then(function(response) {
            vm.allLocations = response;
            setLocationsDependingOnOrderType();
        }, function(error) {
            ToasterService.showError(error.message);
        });

        OrdersApiService.getOrderCollections().then(function(response) {
            vm.collections = [];

            _.forEach(response, function(collection){
                if(collection.currentRank > -6){
                    vm.collections.push(collection);
                }
            })

            if (vm.setCollectionAutomatically) {
                changeOrderSeason();
            }
        }, function(error) {
            ToasterService.showError(error.message);
        });

        OrdersApiService.getDeliveryTerms().then(function(response) {
            vm.deliveryTerms = response;
        }, function(error) {
            ToasterService.showError(error.message);
        });

        OrdersApiService.getUsers().then(function(response) {
            vm.users = response;
        }, function(error) {
            ToasterService.showError(error.message);
        });

        OrdersApiService.getCurrencies().then(function(response) {
            vm.currencies = response;
        }, function(error) {
            ToasterService.showError(error.message);
        });

        Rms2OrdersApiService.getCountries().then(function(response) {
            vm.countries = response.countries;
        }, function(error) {
            ToasterService.showError(error.message);
        });

        setOrderMetadataListeners();
        isDeliveryPlanningEnabled();
    }

    function onChanges() {
    }

    function onDestroy() {
    }

    function orderUpdated() {
        vm.orderChangeCount += 1;
    }

    function setOrderMetadataListeners() {
        // Watch order collection
        $scope.$watch(function() { return vm.order.currencyRate; }, function() {
            OrderService.updateCurrencyOnOrderRows(vm.order.orderArticles, vm.order.currencyRate);
            orderUpdated();
        });
        $scope.$watch(function() { return vm.order.collection.id; }, function() {
            if (vm.order.collection && vm.order.collection.id) {
                OrdersApiService.getOrderCollectionById(vm.order.collection.id).then(function(response) {
                    vm.order.collection = response;

                    //If collection currency doesn't contain all available currencies, add them
                    _.forEach(vm.currencies, function(currency) {
                        var existingCurrency = vm.order.collection.currencySettings.find(function(element) { return element.currency.code === currency.code; });
                        if (existingCurrency === undefined) {
                            var newCurrencySetting = {
                                currency: currency,
                                currencyRate: currency.currencyRate
                            };
                            vm.order.collection.currencySettings.push(newCurrencySetting);
                        }
                    });
                    if (vm.setCurrencyRateAutomatically) {
                        setCurrencyRate();
                    }
                }, function(error) {
                    ToasterService.showError(error.message);
                });
            }

            orderUpdated();
        });
        // Watch order type
        $scope.$watch(function() { return vm.order.orderType.id; }, function() {
            setLocationsDependingOnOrderType();
            orderUpdated();
        });
        // Watch order company
        $scope.$watch(function() { return (vm.order.company) ? vm.order.company.id : undefined; }, function(newValue, oldValue) {
            if (newValue === oldValue) { return; }
            if (vm.order.deliveryTerms === undefined || vm.order.deliveryTerms.id === undefined) {
                setDeliveryTermsToCompanyDefault(vm.order.company);
            }
            setCurrencyToCompanyDefault(vm.order.company);
            setPurchaserToCompanyDefault(vm.order.company);
            orderUpdated();
        });
        // Watch order destination
        $scope.$watch(function() {
            return vm.order.destination;
        }, function() {
            if (vm.order.destination && !vm.order.destination.resellerPriceList &&
                vm.order.destination.resellerPriceListId && vm.order.destination.resellerPriceListId !== -1) {
                //Load reseller price list
                OrdersApiService.getResellerPriceList(vm.order.destination.resellerPriceListId).then(function(response) {
                    vm.order.destination.resellerPriceList = response;
                }, function(error) {
                    ToasterService.showError(error.message);
                });
            }
        });
        //Watch fromLocation
        $scope.$watch(function() {
            return (vm.order.fromLocation === undefined) ? undefined : vm.order.fromLocation.id;
        }, function(oldValue, newValue) {
            if (oldValue !== newValue && vm.order.fromLocation) {
                vm.order.destination = undefined;
                vm.destinations = _.reject(vm.allLocations, function(location) {
                    return location.id === vm.order.fromLocation.id;
                });
                orderUpdated();
            }
        });
        // Watch planned delivery date
        $scope.$watch(function() { return vm.order.plannedDeliveryDate; }, function() {
            orderUpdated();
            if (vm.order.id === undefined || vm.order.id === 0) {
                changeOrderSeason();
            }
        });
         // Watch order delivery terms
        $scope.$watch(function() { return vm.order.deliveryTerms; }, function () { orderUpdated(); });
    }

    function setLocationsDependingOnOrderType() {
        if (vm.order.orderType.orderSystemType === 'store') {
            vm.locations = vm.allLocations;
            vm.destinations = vm.allUserLocations;
            //Clear destination if new order
            if (!vm.order.id || vm.order.id === 0) {
                vm.order.destination = undefined;
            }
        } else if (vm.order.orderType.orderSystemType === 'internal') {
            vm.locations = vm.allUserLocations;
            //Clear destination if new order
            if (!vm.order.id || vm.order.id === 0) {
                vm.order.destination = undefined;
            }
            vm.destinations = _.reject(vm.allLocations, function(location) {
                return location.id === ((vm.order.fromLocation !== undefined) ? vm.order.fromLocation.id : -1);
            });
        } else if (vm.order.orderType.orderSystemType === 'return') {
            vm.locations = vm.allUserLocations;
            //Clear fromLocation if new order
            if (!vm.order.id || vm.order.id === 0) {
                vm.order.fromLocation = undefined;
            }
            vm.destinations = vm.allLocations;
        }
    }

    
    function isDeliveryPlanningEnabled() {
        OrdersApiService.isDeliveryPlanningEnabled().then(function(response){
            vm.enableDeliveryPlanning = response;
        }, function(error){
            ToasterService.showError(error.message);
        });
    }

    function isDeliveryPlanningDisabled(){
        return ((!vm.order.orderType || !vm.order.orderType.id) || vm.order.orderType.deliveryPlanningTemplate === undefined)
    }

    function getOrderTypeRowStyle() {
        var style = {};
        if (!vm.order.orderType || !vm.order.orderType.id) {
            style['color'] = 'white';
            style['background-color'] = errorColor;
        } else {
            style['color'] = noErrorColor;
        }
        return style;
    }

    function getFromLocationRowStyle() {
        var style = {};
        if (vm.order.fromLocation === undefined || !vm.order.fromLocation.id) {
            style['color'] = 'white';
            style['background-color'] = errorColor;
        } else {
            style['color'] = noErrorColor;
        }
        return style;
    }

    function getDestinationRowStyle() {
        var style = {};
        if (vm.order.destination === undefined || !vm.order.destination.id) {
            style['color'] = 'white';
            style['background-color'] = errorColor;
        } else {
            style['color'] = noErrorColor;
        }
        return style;
    }

    function getCompanyRowStyle() {
        var style = {};
        if (vm.order.company === undefined || !vm.order.company.id) {
            style['color'] = 'white';
            style['background-color'] = errorColor;
        } else {
            style['color'] = noErrorColor;
        }
        return style;
    }

    function getCollectionRowStyle() {
        var style = {};
        if (vm.order.collection === undefined || !vm.order.collection.id) {
            style['color'] = 'white';
            style['background-color'] = errorColor;
        } else {
            style['color'] = noErrorColor;
        }
        return style;
    }

    function getCurrencyStyle() {
        var style = {};
        if (vm.order.currency === undefined || !vm.order.currency.id) {
            style['color'] = 'white';
            style['background-color'] = errorColor;
        } else {
            style['color'] = noErrorColor;
        }
        return style;
    }

    function changeOrderSeason() {
        var comparisonDate = parseDate(vm.order.plannedDeliveryDate);
        var collection = _.find(vm.collections, function(collection) {
			var fromDate = parseDate(collection.fromDate);
			var toDate = parseDate(collection.toDate);
            return fromDate <= comparisonDate && toDate >= comparisonDate;
        });

        if (!vm.order.id && vm.order.collection && collection) {
            vm.order.collection = collection;
        }
    }

    function setDeliveryTermsToCompanyDefault(company) {
        if (company === undefined || company.deliveryTerm === undefined) {
            return;
        }

        var deliveryTerm = _.find(vm.deliveryTerms, function(deliveryTerm) { return deliveryTerm.id === company.deliveryTerm.id; });

        if (deliveryTerm !== undefined) {
            vm.order.deliveryTerms = deliveryTerm;
            vm.orderChangeCount += 1;
        }
    }

    function canChangeCurrency() {
        // the currency is dependent on the supplier.
        return vm.isCopying;
    }

    function canChangeCompany() {
        var hasOrderId = vm.order.id !== undefined && vm.order.id > 0;
        var hasNoOrderArticles = vm.order.orderArticles.length === 0;
        var isNotApproved = vm.order.approved === false;
        var hasInitCompany = vm.initCompany && vm.initCompany !== null;

        return (!hasOrderId || (hasNoOrderArticles && isNotApproved)) && !hasInitCompany;
    }

    function isCreatedOrNew(){
        var hasOrderId = vm.order.id !== undefined && vm.order.id > 0;
        var hasPermittedStatus = vm.order.systemStatus === "created";
        return !hasOrderId || hasPermittedStatus
    }

    function canChangeFromLocation() {
        var hasOrderId = vm.order.id !== undefined && vm.order.id > 0;
        var allowedByOrderType = vm.order.orderType.orderSystemType === 'return' || vm.order.orderType.orderSystemType === 'internal';
        var hasNoOrderArticles = vm.order.orderArticles.length === 0;
        var isNotApproved = vm.order.approved === false;
        var isOrderCopy = vm.isCopying === true;

        return !hasOrderId || (allowedByOrderType &&
            ((!isOrderCopy && hasNoOrderArticles) ||
            isNotApproved ||
            isOrderCopy));
    }

    function canChangeCollection() {
        var hasOrderId = vm.order.id !== undefined && vm.order.id > 0;

        return !vm.order.approved && vm.isCreatedOrNew;
    }

    function canChangeDestination() {
        var hasOrderId = vm.order.id !== undefined && vm.order.id > 0;
        var allowedByOrderType = vm.order.orderType.orderSystemType === 'store' || vm.order.orderType.orderSystemType === 'internal';
        var hasNoOrderArticles = vm.order.orderArticles.length === 0;
        var isNotApproved = vm.order.approved === false;
        var isOrderCopy = vm.isCopying === true;
        var hasPermittedStatus = vm.order.systemStatus === "created";

        return !hasOrderId || (allowedByOrderType && hasPermittedStatus &&
            ((!isOrderCopy && hasNoOrderArticles) ||
            isNotApproved ||
            isOrderCopy));
    }

    function setCurrencyToCompanyDefault(company) {
        if (!company || !company.purchasingCurrency) {
            return;
        }

        var currencyToSet = _.find(vm.currencies, function(currency) { return currency.id === company.purchasingCurrency.id; });

        if (currencyToSet !== undefined) {
            vm.order.currency = currencyToSet;
        }

        setCurrencyRate();
    }

    function setPurchaserToCompanyDefault(company) {
        if (!company || !company.primaryPurchaser) {
            return;
        }

        var purchaserToSet = _.find(vm.users, function(user) { return user.id === company.primaryPurchaser.id; });

        if (purchaserToSet !== undefined) {
            vm.order.purchaser = purchaserToSet;
        }
    }

    function setCurrencyToDefault() {
        if (!vm.order.currency) {
            vm.order.currency = vm.defaultCurrency;
            vm.order.currencyRate = vm.defaultCurrency.currencyRate;
        }
    }

    function setCurrencyRate() {
        if (vm.order.currency === undefined) {
            return;
        }

        if (vm.order.collection) {
            var currencySetting = vm.order.collection.currencySettings.find(function(element) { return element.currency.code === vm.order.currency.code; });
            if (currencySetting) {
                vm.order.currencyRate = currencySetting.currencyRate;
            } else {
                vm.order.currencyRate = vm.order.currency.currencyRate;
            }
        } else {
            vm.order.currencyRate = vm.order.currency.currencyRate;
        }
    }

    function showEditDeliveryplanDialog(firstEdit){
        EditDeliveryPlanningDialogService.showDialog(vm.deliveryPlanningTemplate.stages).then(function(response) {
            console.log(response);
            if(response !== false){
                vm.deliveryPlanningTemplate.stages = response;                
            }
            else if(firstEdit){
                vm.deliveryPlanningTemplate = [];
            }
        }, function(error) {
            ToasterService.showError(error.message);
        }).finally(function() {
        });
    }

    function openEditDeliveryPlanning(){
        if(vm.deliveryPlanningTemplate === undefined || vm.deliveryPlanningTemplate.length === 0){
            OrdersApiService.getDeliveryPlanningTemplate(vm.order.orderType.deliveryPlanningTemplate.id, vm.order.plannedDeliveryDate, vm.order.deliveryTerms.id).then(function(response){
                vm.deliveryPlanningTemplate = response.data;
            }, function(error) {
                ToasterService.showError(error.message);
            }).finally(function() {
                showEditDeliveryplanDialog(true);
            });
        }
        else{
            showEditDeliveryplanDialog(false);
        }
    }

    function resetDeliveryPlanningTemplate(){
        vm.deliveryPlanningTemplate = [];
    }

    function dateChangeDeliveryPlanningDialog(){
        if(vm.enableDeliveryPlanning){
            console.log('stuff');
        }
    }

    //Transform from string to Date, and make sure date has correct timezone and no time information
	function parseDate(input) {
		if (!(input instanceof Date)) {
            var newDate = new Date(input);
            return new Date(Date.UTC(newDate.getFullYear(), newDate.getMonth(), newDate.getDate()));
		} else {
			return new Date(Date.UTC(input.getFullYear(), input.getMonth(), input.getDate()));
		}
	}

}
